import { prefectures } from '@/externals/gyym/user'
import { Prefecture, PrefectureId } from '@/externals/gyym/user/prefectures'
import { cacheableAction } from '@/utils/cacheableAction'
import { prefectureSlugMap, prefectureSlugs } from './constants'
import { PrefectureSlug } from './types'

const listAction = cacheableAction(async () => await prefectures.list())

export const listPrefectures = listAction.withCache('prefectures_v1', {
  expiresAfter: 1000 * 60 * 60 * 24,
})

export const prefectureSlugExists = (slug: string) => {
  return prefectureSlugs.includes(slug as PrefectureSlug)
}

export const getPrefectureIdBySlug = (slug: string): PrefectureId | null => {
  return prefectureSlugMap[slug as PrefectureSlug] ?? null
}

export const getPrefectureBySlug = async (slug: string) => {
  const data = await listPrefectures()
  return data.find(
    (prefecture) => prefecture.id === prefectureSlugMap[slug as PrefectureSlug]
  )
}

export const getPrefecture = async (
  prefectureId: PrefectureId
): Promise<Prefecture | undefined> => {
  const data = await listPrefectures()
  return data.find((prefecture) => prefecture.id === prefectureId)
}

export const getPrefectureSlugById = (prefectureId: PrefectureId) => {
  const entry = Object.entries(prefectureSlugMap).find(
    ([_, v]) => v === prefectureId
  )

  return entry ? entry[0] : null
}

/**
 * 都道県名をフォーマット
 */
export const formatPrefectureName = (prefectureName: string): string => {
  return prefectureName.replace(/[都府県]$/, '')
}
